import { useEffect, useState } from 'react';

/**
 * À n'utiliser que lorsque le DOM doit réellement différer d'un breakpoint à l'autre —
 * en pratique : bottom sheet sur mobile contre panneau latéral sur desktop.
 *
 * Tout le reste (bottom nav ↔ barre haute, nombre de colonnes, split view) se fait en CSS
 * pur : pas de bascule visible à l'hydratation, et le mode projection reste capturable.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) return false;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    if (!window.matchMedia) return;
    const list = window.matchMedia(query);
    const onChange = (event: MediaQueryListEvent) => setMatches(event.matches);
    setMatches(list.matches);
    list.addEventListener('change', onChange);
    return () => list.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}

export const TABLET_UP = '(min-width: 768px)';
export const DESKTOP_UP = '(min-width: 1200px)';
